<template>
    <main class="main">
        <div class="container">
            <section-header
                title="Raporty"
                sub-title="
                    Dzięki raportom i statystykom możesz cyklicznie sprawdzać
                    najważniejsze dane dotyczące Twojego sklepu
                "
                class="mb-2 mb-lg-4"
            />
            <div v-if="reports" class="row row-cols-1 row-cols-md-2">
                <div
                    class="col mt-4"
                    v-for="(report, idx) in reports"
                    :key="idx"
                >
                    <div class="c-service is-featured">
                        <div class="d-flex flex-column justify-content-between h-100">
                            <div class="c-service-content">
                                <h2 class="c-service-heading h5 mt-0">
                                    {{ report.heading }}
                                </h2>

                                <div class="c-service-text">
                                    <p>{{ report.description }}</p>
                                </div>
                            </div>
                            <div class="c-service-actions">
                                <div class="c-service-buttons mt-2">
                                    <button
                                        @click="onReportGenerateClick(report)"
                                        class="btn btn-block btn-secondary"
                                    >
                                        Wygeneruj raport
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <page-preloader v-else></page-preloader>
        </div>
        <statistics/>
    </main>
</template>

<script>
import Statistics from '@/views/statistics/Statistics.vue'

export default {
    name: 'Reports',
    components: { Statistics },
    computed: {
        services() {
            return this.$store.getters.getServices
        },
        isShopUser() {
            return this.$store.getters.isShopUser
        }
    },
    async created() {
        if (
            !this.$store.getters.getServices ||
            !this.$store.getters.getServices.length
        ) {
            this.$store.dispatch('servicesFetch')
        }
        const reports = [
            {
                heading: 'Sprawdź dane sprzedażowe dotyczące Twojego sklepu',
                description: 'Raport Mój Sklep',
                moduleName: 'myShop',
                isHidden: this.isShopUser || !this.$store.getters.getMyShopLocationsByAvailableNetworks.length
            },
            {
                heading: 'Sprawdź swoje wyniki w ramach akcji Kreta w rytmie muzyki',
                description: 'Raport z akcji Kreta w rytmie muzyki',
                moduleName: 'targetowka',
                isHidden: this.isShopUser || !this.$store.getters.getTargetReportLocationsByAvailableNetworks.length
            },
            {
                heading: 'Sprawdź użycia promocji w sklepach',
                description: 'Raport użycia promocji w sklepach.',
                moduleName: 'promoCompletions'
            },
            {
                heading: 'Sprawdź użycia promocji',
                description: 'Raport użycia promocji na kasach.',
                moduleName: 'promoUsage'
            },
            {
                heading: this.$brand.reports.diagnostics.title,
                description: 'Raport o stanie komunikacji kas.',
                moduleName: 'diagnostics'
            },
            // temporary disabled
            // {
            //     heading: 'Sprawdź raport PromoPlan',
            //     description:
            //         'Raport informujący o spełnieniu planów sprzedażowych i zadań specjalnych.',
            //     moduleName: 'reportPromoPlan'
            // },
            {
                heading: 'Sprawdź prognozowane rozliczenia promocji',
                description: 'Proste rozliczenie promocji.',
                moduleName: 'reportBillings',
                isHidden: this.isShopUser
            },
            {
                heading: 'Sprawdź raport realizacji celów sprzedażowych',
                description:
                    'Raport przedstawia stopień realizacji celów sprzedażowych.',
                moduleName: 'saleGoals',
                isHidden: this.isShopUser
            },
            {
                heading: 'Sprawdź raport użyć zweryfikowanych negatywnie',
                description:
                    'Raport przedstawia szczegóły odrzuconych użyć promocji.',
                moduleName: 'invalidUsageProducts',
                isHidden:
                    this.isShopUser ||
                    this.$brand.reports.invalidUsageProducts.isHidden
            }
        ]

        if (this.services) {
            const mKasaService = this.$store.getters.mKasaService
            if (mKasaService) {
                reports.push({
                    heading: 'Sprawdź raport M/kasa',
                    description: 'Raport M/kasa.',
                    moduleName: 'mKasa',
                    isHidden: this.$brand.reports.mKasa.isHidden
                })
            }
        }

        this.reports = reports.filter(e => !e.isHidden)
    },
    methods: {
        onReportGenerateClick(report) {
            this.$router.push({ name: report.moduleName })
        }
    },
    data() {
        return {
            reports: null
        }
    }
}
</script>
